<template>
  <v-container>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Feed</v-toolbar-title>
        <v-spacer></v-spacer>
          <Dialog />
          <template v-if="feedOpen == true">
            <v-icon class="ml-2" @click="feedOpen=!feedOpen">mdi-window-minimize</v-icon>
          </template>
          <template v-else>
            <v-icon class="ml-2" @click="feedOpen=!feedOpen">mdi-window-maximize</v-icon>
          </template>
      </v-toolbar>
      <v-card-text v-show="feedOpen">
        <v-data-table
          class="mt-0"
          :headers="headers"
          :items="strains"
          sort-by="acquired"
          :sort-desc="true"
          :items-per-page="10"
        > 
          <template v-slot:[`item.rating`]="{ item }">
            <v-rating v-model="item.rating" small :readonly="true"></v-rating>
          </template>
          <template v-slot:[`item.acquired`]="{ item }">
            <span>{{ item.acquired | moment }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import Dialog from "../components/Dialog";
import { db } from "../db";
export default {
  name: "Feed",
  components: {
    Dialog,
  },
  data: () => ({
    headers: [
      { text: "Cultivar / Strain", value: "cultivar" },
      { text: "Brand", value: "parentage / breeder" },
      { text: "Type", value: "type" },
      { text: "Acquired", value: "acquired" },
      { text: "Rating", value: "rating" },
      { text: "Alias", value: "alias" },
    ],
    strains: [],
    viewForm: false,
    feedOpen: true,
  }),
  methods: {
   
  },
  firestore: {
    strains: db.collection("strains"),
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MM/DD/YY");
    },
  },
};
</script>
